import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page80() {
  useEffect(() => {
    document.title = "Маяк — Страница 79"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page78" />
        <ForwardLink href="/page80" />
      </div>

      <p style={{ textAlign: "right" }}>79.</p>
      <p>Он указывает на ФОНАРНОЕ ОТДЕЛЕНИЕ.</p>
      <p style={{ textAlign: "center" }}>... там наверху!</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я обманывал тебя, старик. Все<br/>
        это время я наблюдал за тобой<br/>
        и я поймал тебя.
      </p>
      <p>СТАРИК смотрит на МОЛОДОГО с жалостью.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Иисус, Мария и Иосиф, Томми.<br/>
        <br/>
        Вчера ночью ты исповедовался,<br/>
        это заставило бы святого побожиться. Мне не в чем<br/>
        признаваться, но ты,<br/>
        Томми, проболтался... вот<br/>
        посмотри, что это с тобой сделало.<br/>
        Это свело тебя с ума. Я знал, что ты сошел с ума,<br/>
        когда ты разбил спасательную лодку<br/>
        только что, гоняясь за мной с топором,<br/>
        пытаясь убить старину Тома.<br/>
        <br/>
        Ты мне не веришь, Томми?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Лучше отдай мне обеденный нож, который ты<br/>
        прикарманил. С ним ты не в безопасности.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Это казенное имущество.
      </p>
      <p>МОЛОДОЙ делает это с видом виноватого ребенка.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Вот и молодец.
      </p>
      <p>
        СТАРИК, наступив на него, ломает его пополам и бросает<br/>
        в печку.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Вычту из твоего жалования.
      </p>
      <p style={{ textAlign: "right" }}>79.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page78" />
        <ForwardLink href="/page80" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710635700/the-lighthouse-script/krjnpj2y1yziabjhfqlu.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page80;
